<template>
  <div class="k-table-controls-container">
    <div class="k-table-controls">
      <div class="k-table-controls-left">
        <button
          v-if="hideable && hasHideableColumns"
          class="btn btn-primary"
          @click="onToggleColumnSelector"
          aria-label="Toggle column visibility"
          :aria-expanded="isColumnSelectorOpen"
        >
          Columns
          <i class="fas fa-columns-3" aria-hidden="true"></i>
        </button>

        <div
          v-if="isColumnSelectorOpen && hasHideableColumns"
          class="k-table-column-selector"
          role="dialog"
          aria-label="Column visibility options"
        >
        <div class="k-table-column-selector-container">
          <ul v-if="colSelectorOptions.length > 0" class="k-table-special-selectors">
            <div class="k-table-column-selector-header">
              <h3>Special filters</h3>
            </div>
            <li v-for="(colSelector, index) in colSelectorOptions" :key="colSelector.text">
              <label class="k-custom-checkbox">
                <input type="checkbox" v-model="activeColSelectors" :value="index" @change="onFilterToggle(activeColSelectors)" class="hidden-checkbox"/>
                <span class="k-custom-checkbox-box"></span>
                <span class="k-custom-checkbox-text">{{ colSelector.text }}</span>
              </label>
            </li>
          </ul>
        </div>
        <div v-if="colSelectorOptions.length > 0" class="dropdown-divider"><hr></div>
        <div class="k-table-column-selector-header">
          <h3>Visible Columns</h3>
          <button
            class="btn btn-link"
            @click="onResetColumns"
            aria-label="Reset column visibility"
          >
            Reset
          </button>
        </div>
          <div class="k-table-column-selector-content">
            <div
              v-for="key in hideableKeys"
              :key="key"
              class="k-table-column-selector-item"
            >
              <label class="k-custom-checkbox">
                <input
                  type="checkbox"
                  class="hidden-checkbox"
                  :checked="shownKeys.includes(key)"
                  @change="onColumnToggle(key, $event)"
                  :aria-label="`Toggle ${headers[key].name} column`"
                >
                <span class="k-custom-checkbox-box"></span>
                <span class="k-custom-checkbox-text">{{ headers[key].name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="k-table-controls-right">
        <div class="k-table-controls-group">
          <button
            v-if="downloadable"
            class="btn btn-outlined"
            @click="onDownload"
            aria-label="Download table data"
          >
            Download (.csv)
            <i class="fas fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="k-table-legend" v-if="showLegend">
        <span><i class="fas fa-square optional"></i> Optional</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableControls',

  props: {
    headers: {
      type: Object,
      required: true,
    },
    shownKeys: {
      type: Array,
      required: true,
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
    colSelectorOptions: {
      type: Array,
      default: () => [],
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    hideable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isColumnSelectorOpen: false,
      activeColSelectors: [],
    };
  },

  computed: {
    hideableKeys() {
      return Object.keys(this.headers).filter(key => this.headers[key].hideable);
    },

    hasHideableColumns() {
      return this.hideableKeys.length > 0;
    },
  },

  methods: {
    onToggleColumnSelector() {
      this.isColumnSelectorOpen = !this.isColumnSelectorOpen;
    },

    onColumnToggle(key, event) {
      const checked = event.target.checked;
      const newShownKeys = checked
        ? [...this.shownKeys, key]
        : this.shownKeys.filter(k => k !== key);

      this.$emit('update:shownKeys', newShownKeys);
    },

    onFilterToggle() {
      this.$emit('update:activeColSelectors', this.activeColSelectors);
    },

    onResetColumns() {
      this.$emit('reset-columns');
    },

    onDownload() {
      this.$emit('download');
    },
  },
};
</script>
